import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { TestContactList, TestContactListsResponse } from '../types';

interface UseTestContactListsParams {
  identityId: string;
  accountId: string;
}

export const useTestContactLists = ({
  identityId,
  accountId,
}: UseTestContactListsParams) => {
  const { data, isLoading, error } = useQuery<TestContactListsResponse>({
    queryKey: ['test-contact-lists', identityId, accountId],
    queryFn: async () => {
      const response = await api.get<TestContactListsResponse>(
        `/phonelists/testlists?identity_id=${identityId}&account_id=${accountId}`
      );
      return response.data;
    },
    enabled: !!identityId && !!accountId,
  });

  return {
    testLists: data || [],
    isLoading,
    error,
  };
};

export const useTestContactList = (listId: number | null) => {
  const { data, isLoading, error } = useQuery<TestContactList>({
    queryKey: ['test-contact-list', listId],
    queryFn: async () => {
      if (!listId) throw new Error('No list ID provided');

      const response = await api.get<TestContactListsResponse>(
        `/phonelists/testlists?list_id=${listId}`
      );

      // The API returns an array, but we're querying for a specific list,
      // so we expect only one result
      const list = response.data[0];
      if (!list) throw new Error('Test list not found');

      return list;
    },
    enabled: !!listId,
  });

  const contacts = data?.test_contact_phones || [];

  return {
    testList: data,
    contacts,
    isLoading,
    error,
  };
};
